import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class PopupMessage extends BaseModel {
}

decorate(PopupMessage, {
  id: observable,
  type: observable,
  title: observable,
  message: observable,
});

/**
 * order states translations:
 * t('popup.model.types.success')
 * t('popup.model.types.info')
 * t('popup.model.types.warning')
 * t('popup.model.types.error')
 */
export const PopupType = Object.freeze({
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
});
